import { DefaultBadge } from '@frontend/components/badge';
import { TransactionStateName } from '@frontend/transaction/types';
import useTransactionStateBadge from './transaction-state-badge.controller';

const ID = 'transaction-state-badge';
export interface TransactionStateBadgeProps {
    state: TransactionStateName;
}

export const TransactionStateBadge = (props: TransactionStateBadgeProps) => {
    const viewProps = useTransactionStateBadge(props);
    return (
        <DefaultBadge
            id={ID}
            label={viewProps.displayName}
            styles={{ container: { color: viewProps.type } }}
        />
    );
};
